import { useEffect, useState } from "react";
import api from "../api";
import { useApp } from "../context/AppContext";
import { Seo } from "../components/Seo";

const PAGES = {
  about: {
    title: "About Us",
    body: "DocGalaxy Gujarat Property Services is a private digital assistance platform that helps property owners, buyers, sellers, brokers, advocates, document writers, banks and citizens request, obtain and manage Gujarat property documents online.\n\nWe started in Rajkot and serve all 33 districts of Gujarat with document assistance, verification support, calculators and education around registration, e-stamping and GARVI 2.0.\n\nWe are not a government department and do not claim affiliation with any government portal.",
  },
  privacy: {
    title: "Privacy Policy",
    body: "We collect only the information needed to fulfil your document and verification requests: name, contact details, property identifiers and uploaded supporting documents.\n\nYour documents are stored privately in encrypted object storage and are never publicly accessible. Downloads are authenticated and audit-logged.\n\nWe never sell your data. Payment details are processed by Razorpay; we never see or store your card numbers.",
  },
  terms: {
    title: "Terms & Conditions",
    body: "DocGalaxy provides document assistance and information services. Processing times are estimates. Government fees, if any, are charged at actuals.\n\nDelivered documents are obtained through lawful channels. Verification reports are information-assistance only and do not replace independent legal advice.\n\nBy using this platform you agree not to submit false information or misuse obtained documents.",
  },
  "refund-policy": {
    title: "Refund Policy",
    body: "If we cannot deliver your requested document, you receive a full refund of the service fee.\n\nRefund requests are accepted while the order is in Pending or Processing status. Once a document is delivered, fees are non-refundable.\n\nRefunds are processed to the original payment method within 5-7 working days.",
  },
  disclaimer: {
    title: "Disclaimer",
    body: "DocGalaxy is a private digital assistance/service platform and is NOT a government website. We are not affiliated with any government department, portal or agency unless a specific government integration officially authorizes it.\n\nOnline verification is an information-assistance service and is not a substitute for independent legal advice or official government verification.\n\nCalculator results are indicative; confirm current rates and rules with the competent authority.",
  },
};

export function StaticPage({ pageKey }) {
  const p = PAGES[pageKey] || PAGES.about;
  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid={`static-page-${pageKey}`}>
      <Seo title={p.title} description={p.body.slice(0, 150)} />
      <h1 className="font-display font-bold text-3xl md:text-4xl">{p.title}</h1>
      <div className="mt-6 space-y-4">
        {p.body.split("\n").filter(Boolean).map((para, i) => <p key={i} className="text-foreground/80 leading-relaxed">{para}</p>)}
      </div>
    </div>
  );
}

export function FaqPage() {
  const { lang, t } = useApp();
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid="faq-page">
      <Seo title="FAQ" description="Frequently asked questions about DocGalaxy Gujarat property document services." />
      <script type="application/ld+json">{JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q_en, acceptedAnswer: { "@type": "Answer", text: f.a_en } })),
      })}</script>
      <h1 className="font-display font-bold text-3xl md:text-4xl">{t("faq")}</h1>
      <div className="mt-6 space-y-3">
        {faqs.map((f) => (
          <details key={f.id} className="bg-white border border-border rounded-xl p-4 group" data-testid={`faq-${f.id}`}>
            <summary className="font-semibold cursor-pointer list-none flex justify-between items-center">
              {lang === "gu" && f.q_gu ? f.q_gu : f.q_en}
              <span className="text-primary group-open:rotate-45 transition-transform text-xl leading-none">+</span>
            </summary>
            <p className="text-sm text-muted-foreground mt-3 leading-relaxed">{lang === "gu" && f.a_gu ? f.a_gu : f.a_en}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
